// src/components/RecipeListItem.tsx
import React from 'react';
import { Recipe } from '../../api/Types';
import FavoriteButton from './FavoriteButton';
import { Badge, Box, Flex, FlexLink, Heading, ListGroupItem, Text, Thumbnail } from '../ui';

interface RecipeListItemProps {
  recipe: Recipe;
  isFavorite: boolean;
  onFavoriteClick: () => void;
  favoriteDisabled?: boolean;
}

const RecipeListItem: React.FC<RecipeListItemProps> = ({
  recipe,
  isFavorite,
  onFavoriteClick,
  favoriteDisabled = false,
}) => {
  const imageUrl = recipe.image || `${process.env.PUBLIC_URL}/marmite.png`;

  return (
    <Flex as={ListGroupItem} align="center" background="white">
      <FlexLink
        to={`/edit-recipe/${recipe.id}`}
        align="center"
        flexGrow
        textDecoration="none"
        textReset
      >
        <Thumbnail
          src={imageUrl}
          alt={recipe.title}
          marginEnd={3}
          size={80}
        />
        <Box>
            <Heading as="h5" marginBottom={0} textColor="dark" style={{ whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word' }}>{recipe.title}</Heading>
            {recipe.authors && (
                <Text marginBottom={0} style={{ fontSize: '0.85em', color: recipe.authors.color || undefined }}>
                    Par {recipe.authors.first_name} {recipe.authors.name}
                </Text>
            )}
            {recipe.tags && recipe.tags.length > 0 && (
              <Flex wrap marginTop={1}>
                {recipe.tags.map(tag => (
                  <Badge key={tag.id} variant="secondary" marginEnd={1} marginBottom={1} style={{ fontSize: '0.7em' }}>
                    {tag.name}
                  </Badge>
                ))}
              </Flex>
            )}
        </Box>
      </FlexLink>
      <Box marginStart={3}>
        <FavoriteButton
          isFavorite={isFavorite}
          onClick={onFavoriteClick}
          disabled={favoriteDisabled}
        />
      </Box>
    </Flex>
  );
};

export default RecipeListItem;
